module.exports = __webpack_public_path__ + "img/ararat-age-confirm-bg.1447ba6d.jpg";